'use strict';

var React = require('react');
var svtdate = require('../../utils/svtdate');

module.exports = React.createClass({

	displayName: 'Duration',

	propTypes: {
		seconds: React.PropTypes.number.isRequired
	},

	_getPubDateString: function (pubDateString) {
		var pubDate = svtdate.parseIsoString(pubDateString);
		return svtdate.formatPublicationDate(pubDate);
	},


	render: function () {
		var {seconds, ...other } = this.props;

		if (!seconds) {
			return false;
		}

		return (
			//<time {...other} datetime={'P'+seconds+'S'}>{seconds}</time>
			<time {...other} className="svtse_episode__fig-play-time" dateTime={'P'+seconds+'S'}>{svtdate.formatDuration(seconds)}</time>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/elements/Duration.jsx
 **/